/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH3Icon24Solid = forwardRef('SettingsSlidersH3Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18.782 3.875H21a1.125 1.125 0 0 1 0 2.25h-2.218a3 3 0 0 1-5.564 0H3a1.125 1.125 0 0 1 0-2.25h10.218a3 3 0 0 1 5.564 0Z" }),
        React.createElement("path", { d: "M3 10.875a1.125 1.125 0 0 0 0 2.25h2.218a3.001 3.001 0 0 0 5.564 0H21a1.125 1.125 0 0 0 0-2.25H10.782a3 3 0 0 0-5.564 0H3Z" }),
        React.createElement("path", { d: "M3 17.875a1.125 1.125 0 0 0 0 2.25h10.218a3.001 3.001 0 0 0 5.564 0H21a1.125 1.125 0 0 0 0-2.25h-2.218a3.001 3.001 0 0 0-5.564 0H3Z" })));
});
